const navigationList = [
	// {
	//   name: '审核管理',
	//   icon: require('../assets/imgs/rizhi.svg'),
	//   path: '',
	//   child: [
	//     {
	//       name: '报名信息审核',
	//       icon: '',
	//       path: '/layout/information'
	//     }
	//   ]
	// },
	{
		name: '首页',
		icon: require('../assets/imgs/home.png'),
		path: '',
		child: [
			{
				name: '统计看板',
				icon: '',
				path: '/layout/homepage'
			}
		]
	},
	{
		name: '比赛管理',
		icon: require('../assets/imgs/compt.png'),
		path: '',
		child: [
			{
				name: '比赛管理',
				icon: '',
				path: '/layout/competition'
			},
			{
				name: '比赛详情',
				icon: '',
				path: '/layout/matchDetails'
			}
		]
	},
	{
		name: '运营管理',
		icon: require('../assets/imgs/yunying.png'),
		path: '',
		child: [
			{
				name: '轮播图',
				icon: '',
				path: '/layout/slideshow'
			},
			{
				name: '大赛资讯',
				icon: '',
				path: '/layout/mediaReports'
			},
			{
				name: '成果展示',
				icon: '',
				path: '/layout/resultsShow'
			},
			{
				name: '帖子管理',
				icon: '',
				path: '/layout/postManagement'
			},
			{
				name: '消息管理',
				icon: '',
				path: '/layout/messageNotice'
			}
		]
	},
	// {
	//   name: '比赛管理',
	//   icon: require('../assets/imgs/yunying.svg'),
	//   path: '',
	//   child: [
	//     {
	//       name: '上传资料时间',
	//       icon: '',
	//       path: '/layout/uploadData'
	//     }
	//   ]
	// },
	{
		name: '用户管理',
		icon: require('../assets/imgs/users.png'),
		path: '',
		child: [
			{
				name: '注册用户',
				icon: '',
				path: '/layout/registered'
			},
			{
				name: '后台用户',
				icon: '',
				path: '/layout/background'
			},
			{
				name: '实名认证',
				icon: '',
				path: '/layout/realnameAuth'
			}
		]
	},
	{
		name: '模型市场',
		icon: require('../assets/imgs/system.png'),
		path: '',
		child: [
			{
				name: '服务管理',
				icon: '',
				path: '/layout/serviceManagement'
			},
			{
				name: '模型管理',
				icon: '',
				path: '/layout/modelManagement'
			}
		]
	},
	{
		name: '系统管理',
		icon: require('../assets/imgs/system.png'),
		path: '',
		child: [
			{
				name: '部门管理',
				icon: '',
				path: '/layout/depart'
			},
			{
				name: '角色管理',
				icon: '',
				path: '/layout/role'
			}
		]
	}
]
const navigationList_c = [
	{
		name: '首页',
		icon: '',
		path: '/layout_c/home'
	},
	{
		name: '大赛介绍',
		icon: '',
		path: '/layout_c/announcement'
	},
	{
		name: '我的比赛',
		icon: '',
		path: '/layout_c/myCompet'
	},
	{
		name: '相关新闻',
		icon: '',
		path: '',
		child: [
			{
				name: '小诤-世界品牌莫干山大会',
				icon: '',
				path: 'https://m.weibo.cn/status/5296368429043486?wm=3333_2001&from=10F8293010&sourcetype=weixin&s_trans=2677879562_5296368429043486&s_channel=4&jumpfrom=weibocom'
			},
			{
				name: '2025企业家博鳌论坛：“新华杯”AI审校与写作大赛启动',
				icon: '',
				path: 'https://www.news.cn/enterprise/20251204/28c7f813b91d404498f706f50595b29b/c.html'
			},
			{
				name: '新华杯AI审校与写作大赛详情',
				icon: '',
				path: 'https://h.xinhuaxmt.com/vh512/share/12864000?docid=12864000&newstype=1001&d=1350248&channel=weixin&time=1767003416409'
			},
			// {
			// 	name: '新华杯AI审校与写作大赛相关报道',
			// 	icon: '',
			// 	path: 'https://h.xinhuaxmt.com/vh512/share/12516243?d=134ff3b&channel=weixinp&wxst=1745764954719&time=1767004083199'
			// }
		]
	}
]

exports.navigationList_c = navigationList_c
exports.navigationList = navigationList
